// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2_SNu","tab":"ProcedureTabs_tab__2Vq5H"};